<template lang="pug">
  .wrap
    #loading(v-if="!merkliste && loading") 
      loading
    .merklisten(v-else)
      .wrap
        .metanav
          .left
            router-link(:to="{ name: 'home' }") {{ $t(`Zurück zur Fundus Übersicht`) }}
            router-link(to="/merklisten") {{ $t(`Merkliste verwalten`) }}
            strong {{ $t(`Vorschau`) }}: {{ merkliste.name }}
      .wrap.wrap--vorschau
        .uebersicht#merkliste
          .grid(v-if="merkliste.items.length > 0")
            fundus-tile(v-for="fundus in merkliste.items" :fundus="fundus.item" :listQuantity="parseInt(fundus.quantity)" :key="fundus.id").fundus
</template>

<script>
import FundusTile from '@/components/FundusTile.vue'
import { getMerklisteVorschau as apiGetMerklisteVorschau } from '@/api'
import Loading from '@/components/Loading.vue'
export default {
  name: 'MerklisteVorschau',
  metaInfo () {
    return {
      title: 'Merklisten Vorschau'
    }
  },
  data: () => ({
    loading: false,
    merkliste: null
  }),
  components: {    
    Loading,
    FundusTile
  },
  async created() {
    try {
      this.loading = true
      this.merkliste = await apiGetMerklisteVorschau({ slug: this.$route.params.slug })
      this.loading = false
    } catch (error) {
      this.loading = false
      console.error(error)
    }
  },
}
</script>

<style scoped lang="sass">
.listview:first-child
  margin-left: 0 !important
  grid-column-start: 1
  @media only screen and (max-width: 400px)
    grid-column-start: inherit
.grid
  display: grid
  grid-template-columns: repeat(3, 1fr)
  grid-gap: 20px
  @media only screen and (max-width: 1000px)
    grid-template-columns: repeat(3, 1fr)
  @media only screen and (max-width: 769px)
    grid-template-columns: repeat(2, 1fr)
  @media only screen and (max-width: 400px)
    grid-template-columns: inherit
</style>
